import { AdvancedSelect } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import useStyles from './AvailableForTestingFilter.styles'

export type SelectOption = {
  value: string
  label: string
}

export type TestingAvailability = 'available'

type AvailableForTestingFilterProps = {
  onChange: (v: SelectOption | null) => void
  isDisabled?: boolean
  defaultValue?: TestingAvailability
}

const AvailableForTestingFilter = ({
  onChange,
  isDisabled,
  defaultValue,
}: AvailableForTestingFilterProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const options = [
    {
      value: 'available' as const,
      label: t('Available'),
    },
  ]
  const defaultOption = options.find((filter) => filter.value === defaultValue)

  return (
    <div className={classes.select}>
      <AdvancedSelect<SelectOption>
        name="availabilityFilter"
        id="availabilityFilter"
        options={options}
        onChange={onChange}
        placeholder={t('Filter...')}
        label={t('Testing availability')}
        isDisabled={isDisabled}
        defaultValue={defaultOption}
        isClearable
      />
    </div>
  )
}

export default AvailableForTestingFilter
